import { render, staticRenderFns } from "./reportSeniorDetails.vue?vue&type=template&id=12a3200f&scoped=true&"
import script from "./reportSeniorDetails.vue?vue&type=script&lang=js&"
export * from "./reportSeniorDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportSeniorDetails.vue?vue&type=style&index=0&id=12a3200f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3200f",
  null
  
)

export default component.exports